<template>
    <div class="modal fade" id="createCampaignModal" ref="createCampaignModal" tabindex="-1" role="dialog" aria-labelledby="createCampaignModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row w-100 ml-0 mr-0">
                        <div class="col-12">
                            <img class="w-75 d-block m-auto-custom" src="./../../assets/create_campaign.svg" alt="create campaign" />
                        </div>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="createCampaignModalLabel">{{ $t('create_campaign.create_own_campaign') }}</h5>
                        </div>
                    </div>
                    <div class="mt-3">
                        <div class="form-group position-relative">
                            <span class="login-input-title float-left">{{ $t('create_campaign.campaign_name_text') }}</span>
                            <input type="text" class="form-control form-control--canvassing border-bottom" :placeholder="$t('create_campaign.campaign_name')" v-model="form.name" id="name">
                            <div v-if="hasError(errors, 'name')">
                                <span class="text-danger">{{errors.name[0]}}</span>
                            </div>
                        </div>
                        <div class="form-group position-relative">
                            <span class="login-input-title float-left" id="location">{{ $t('create_campaign.campaign_location_text') }}</span>
                            <gmap-autocomplete
                                ref="autocompletecampaign"
                                @place_changed="setPlace"
                                :placeholder="$t('create_campaign.campaign_location')"
                                :select-first-on-enter="true"
                            >
                            </gmap-autocomplete>
                            <div v-if="hasError(errors, 'location')">
                                <span class="text-danger">{{errors.location[0]}}</span>
                            </div>
                        </div>
                        
                        <button @click.prevent="doCreateCampaign" class="btn shadow btn-app btn-block mb-5 mt-5 primaryBackground">{{ $t('create_campaign.create_campaign_button') }}</button>
                    </div>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";
    import { gmapApi } from 'vue2-google-maps';

    export default {
        name: "CreateCampaignModal",
        mixins: [HelperMixin],
        data() {
            return {
                form: {
                    name: "",
                    location: {},
                },
                errors: {
                    name: [],
                    location: [],
                }
            }
        },
        created() {
        },
        computed: {
            google: gmapApi,   
        },
        mounted() {
            $(this.$refs['createCampaignModal']).on('hide.bs.modal', this.resetForm);
            $(this.$refs['createCampaignModal']).on('hide.bs.modal', this.resetErrors);
        },
        methods: {
            setPlace(place) {
                this.form.location = {
                    full_address: place.formatted_address,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
            },

            resetForm() {
                this.form = {
                    name: "",
                    location: {},
                };
                this.$refs.autocompletecampaign.$el.value = '';
            },
             resetErrors() {
                this.errors = {
                    name: [],
                    location: [],
                };
            },
            doCreateCampaign(evt) {
                
                this.resetErrors();
                evt.preventDefault();
                if (typeof this.form.location.id != 'undefined') {
                    delete this.form.location.id;
                }
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                        '/api/v1/campaign/create',
                        this.form,
                        config
                ).then(this.consumedoCreateCampaign, this.errordoCreateCampaign);
            },

            consumedoCreateCampaign: function (response) {
                var camp = response.data.data;
                camp.status = 'active';

                this.$store.dispatch('addToTopOfCampaignsList', {
                    campaign: camp
                });
                this.resetForm();
                this.refreshData();
                $('#createCampaignModal').modal('hide');

                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            errordoCreateCampaign: function (error) {
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.name != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.name.includes("required")) {
                                this.errors.name = [this.$t('create_campaign.errors.name_required')];
                            }
                            if (error.response.data.errorMessage.validation_fail.name.includes("min")) {
                                this.errors.name = [this.$t('create_campaign.errors.name_min')];
                            }
                            if (error.response.data.errorMessage.validation_fail.name.includes("max")) {
                                this.errors.name = [this.$t('create_campaign.errors.name_max')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.location != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.location.includes("required")) {
                                this.errors.location = [this.$t('create_campaign.errors.location_required')];
                            }
                            if (error.response.data.errorMessage.validation_fail.location.includes("location")) {
                                this.errors.location = [this.$t('create_campaign.errors.location_required')];
                            }
                        }
                    }
                }
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
               console.log(error);
            },
        },
    };
</script>
